import { cloneElement, memo, ReactNode, useCallback, useMemo } from 'react'
import cn from 'classnames'
import { ClickOutside } from 'components/helpers/ClickOutside'

import { CloseButton } from '../CloseButton'
import { TSize } from '../ModalDesktop'

import s from './DialogDesktop.module.less'
import cs from 'src/common.module.less'

interface IProps {
  children: ReactNode
  isCloseButton: boolean
  isCloseOnOutsideClick: boolean
  isOffsets: boolean
  size: TSize
  className?: string
  footer?: JSX.Element
  header?: JSX.Element
  id?: string
  isOrder?: boolean
  noPadding?: boolean
  onClose?: () => void
}

export const DialogDesktop = memo<IProps>(function DialogDesktop({
  children,
  className,
  footer,
  header,
  id,
  isCloseButton,
  isCloseOnOutsideClick,
  isOffsets,
  onClose,
  size,
  isOrder,
  noPadding
}) {
  const handleClickOutside = useCallback(() => {
    if (isCloseOnOutsideClick && onClose) {
      onClose()
    }
  }, [isCloseOnOutsideClick, onClose])

  const headerRender = useMemo(() => {
    const closeButton = isCloseButton ? <CloseButton onClick={onClose} /> : undefined

    return header ? cloneElement(header, { closeButton }) : null
  }, [header, isCloseButton, onClose])

  return (
    <ClickOutside
      data-component="modal"
      id={id}
      onClickOutside={handleClickOutside}
      className={cn(s.DialogDesktop, isOrder ? s.isOrder : '', className, cs.shadowFive, s[size], {
        [s.DialogDesktop_offsets]: isOffsets,
        [s.DialogDesktop_withClose]: isCloseButton
      })}
    >
      {headerRender}
      <div className={cn(s.body, noPadding ? s.noPadding : '')}>{children}</div>
      {footer}
    </ClickOutside>
  )
})
